import { useCreatorStudioStore } from '../stores/CreatorStudioStore';
import ImagesManager from './ImagesManager';

class CreditManager {

    constructor() {
    }

    currentNumberOfImages() {
        this.store = useCreatorStudioStore();
        const { batch_size, batch_count } = this.store.creatorStudio.settings.conversion.options;

        return ImagesManager.getByBatchSizeAndCount(batch_size, batch_count).number;
    }
        
    totalCost() {
        return this.currentNumberOfImages();
    }
}

export default new CreditManager()